<template>
<div :class="headless ? '' : 'card'">
  <div :class="headless ? 'py-3' : 'card-body'">
            <div class="row">
              <div :class="headless ? 'col-md-6 mx-auto' : 'col'">
                <div class="text-center" v-if="!user.bank_name">No information</div>
                  <div v-else>
                    <table class="table">
              <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3" width="50%">Bank</th>
                  <th class="first-right pl-3" width="50%">Account Name</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                    <td class="pl-3">{{user.bank_name}}</td>
                    <td class="pl-3">{{user.bank_account_name}}</td>
                </tr>
              </tbody>
            </table>
            <table class="table mt-2">
              <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3" width="50%">Account Number</th>
                  <th class="first-right pl-3" width="50%">Branch Code</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                    <td class="pl-3 pb-0">{{user.bank_account_number}}</td>
                    <td class="pl-3 pb-0">{{user.bank_branch_code}}</td>
                </tr>
              </tbody>
            </table>
                  </div>
              </div>
            </div>
          </div>
        </div>
</template>

<script>
export default {
  props: ['user','headless'],
};
</script> 

<style scoped>
.table .thead-dark th {
  font-weight:bold;
  background: none !important;
  color: #1a202c !important;
  font-size: 0.9rem !important;
  padding:0;
}
</style>